import React, {FC} from 'react';

import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface BannerProgressProps {
  /** A fraction indicating the progress to display. */
  progress: number;
}

/*
 * Style.
 */

interface BannerProgressStyleProps {
  $progress: number;
}

const StyledProgressDiv = styled.div<BannerProgressStyleProps>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  transform: scaleX(${(p) => 1 - p.$progress});
  transform-origin: right;
  transition: transform 300ms ease-in-out;
  background-color: ${(p) => p.theme.bannerTimeRemaining};
`;

/*
 * Component.
 */

export const BannerProgress: FC<BannerProgressProps> = (props) => (
  <StyledProgressDiv $progress={props.progress} />
);
